import React, { Component } from 'react'
import classNames from 'classnames'
import moment from 'moment'

export default class StatusBar extends Component {
  static defaultProps = {
    platform: 'ios',
    light: false,
    hasNotch: false,
  }

  render() {
    let { platform, hasNotch, light } = this.props
    let typeString = platform

    if (hasNotch) {
      typeString = `${typeString}-notch`
    }

    switch (typeString) {
      case 'ios':
        return <StatusBarIOS light={light} />
      case 'ios-notch':
        return <StatusBarIPhoneX light={light} />
      case 'android':
        return <StatusBarAndroid light={light} />
      case 'android-notch':
        return <StatusBarAndroidNotch light={light} />
      default:
        console.error('Invalid params:', { platform, hasNotch })

        return null
    }

  }
}

class BaseStatusBar extends Component {
  render() {
    let { light } = this.props

    let color = light ? 'light' : 'dark'

    return (
      <div className={classNames(
        'status-bar',
        `status-bar-${color}`,
        this.getClassName()
      )}>
        {this.renderElements()}
      </div>
    )
  }
}

class StatusBarElement extends Component {
  static defaultProps = {
    align: 'center',
  }

  renderContent() {
    return this.props.children
  }

  render() {
    let { type, align } = this.props

    return (
      <div className={classNames(
        'status-bar-element',
        `status-bar-element-${type}`,
        `status-bar-element-align-${align}`,
      )}>
        {this.renderContent()}
      </div>
    )
  }
}

class StatusBarIcon extends StatusBarElement {
  renderContent() {
    let { type } = this.props

    return (
      <div
        className={classNames('status-bar-icon', `status-bar-icon-${type}`)}
      />
    )
  }
}

class StatusBarIOS extends BaseStatusBar {
  getClassName() {
    return 'status-bar-ios status-bar-ios-standard'
  }

  renderElements() {
    return (
      <React.Fragment>
        <StatusBarIcon type="bars-ios" />
        <StatusBarElement type="time-ios">
          <Clock includeAmPm />
        </StatusBarElement>
        <StatusBarIcon type="battery-ios" />
      </React.Fragment>
    )
  }
}

class StatusBarIPhoneX extends BaseStatusBar {
  getClassName() {
    return 'status-bar-ios status-bar-ios-notch'
  }

  renderElements() {
    return (
      <React.Fragment>
        <StatusBarElement type="time-iphonex">
          <Clock />
        </StatusBarElement>
        <StatusBarIcon type="bars-iphonex" />
      </React.Fragment>
    )
  }
}

class StatusBarAndroid extends BaseStatusBar {
  getClassName() {
    return 'status-bar-android status-bar-android-standard'
  }

  renderElements() {
    return (
      <React.Fragment>
        <StatusBarElement type="time-android">
          <Clock />
        </StatusBarElement>
        <StatusBarIcon type="android-combined" />
      </React.Fragment>
    )
  }
}

const getTime = includeAmPm => {
  let format = includeAmPm ? 'h:mm A' : 'h:mm'

  let time = moment()
  time.locale('en')

  return time.format(format)
}

class Clock extends Component {
  static defaultProps = {
    includeAmPm: false
  }

  constructor(props) {
    super(props)

    this.state = { time: getTime(props.includeAmPm) }
  }

  componentDidMount() {
    this._interval = window.setInterval(this.updateTime, 1000)
  }

  componentWillUnmount() {
    window.clearInterval(this._interval)
  }

  updateTime = () => {
    let time = getTime(this.props.includeAmPm)

    if (time !== this.state.time) {
      this.setState({ time })
    }
  }

  render() {
    let { time } = this.state

    return (
      <div className="status-bar-clock">
        {time}
      </div>
    )
  }
}
